module.exports = __webpack_public_path__ + "img/hand-holding-usd-solid updated.da73cdf1.svg";